import React from 'react';
import { Box, useTheme } from '@mui/material';

/**
 * Wordmark icon — CSS flex centering (not SVG <text>).
 * SVG dominant-baseline is inconsistent on Safari / some Android WebViews
 * and made "CH" look shifted upward.
 */
const BrandMark = ({ size = 36, sx = {}, alt = 'CrafterHack', variant = 'default' }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const onDarkChrome = variant === 'header' && isDark;

  const bg = onDarkChrome ? '#ffffff' : '#0a0a0a';
  const cColor = onDarkChrome ? '#0a0a0a' : '#ffffff';
  const hColor = '#f50057';
  const radius = Math.max(6, Math.round(size * (8 / 36)));
  const fontSize = size * (22 / 36);

  return (
    <Box
      role="img"
      aria-label={alt}
      sx={{
        width: size,
        height: size,
        borderRadius: `${radius}px`,
        bgcolor: bg,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        userSelect: 'none',
        lineHeight: 1,
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          fontWeight: 900,
          fontSize,
          letterSpacing: '-0.06em',
          lineHeight: 1,
          // Sit slightly higher — previous nudge pushed CH too far down
          transform: 'translateY(-0.06em)',
        }}
      >
        <Box component="span" sx={{ color: cColor }}>
          C
        </Box>
        <Box component="span" sx={{ color: hColor }}>
          H
        </Box>
      </Box>
    </Box>
  );
};

export default BrandMark;
